import { render } from "./AddPartner.vue?vue&type=template&id=aaa85152"
import script from "./AddPartner.vue?vue&type=script&lang=js"
export * from "./AddPartner.vue?vue&type=script&lang=js"

import "./AddPartner.vue?vue&type=style&index=0&id=aaa85152&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__